/**
 * RelivConferenceOrderItem
 * @param skuNumber
 * @param type
 */
var RelivConferenceOrderItem = function (skuNumber, type) {
    /**
     * self
     */
    var self = this;
    /**
     * data *REQUIRED
     * @type {string}
     */
    self.data = [];
    /**
     * qty *REQUIRED
     * @type {null}
     */
    self.qty = 1;
    /**
     * skuNumber *REQUIRED
     * @type {string}
     */
    self.skuNumber = skuNumber;
    /**
     * type *REQUIRED
     * @type {string}
     */
    self.type = type;
};

export default RelivConferenceOrderItem;
